export default __webpack_public_path__ + "static/media/logo_dark.835f2059.svg";